// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vA6D","buttons":"styles_buttons__1is3d"};